'use client'

import { usePathname } from 'next/navigation'

import { Paragraph } from '@graftcode/design-system'
import { useShallow } from 'zustand/react/shallow'

import { LOADER_TEST_IDS } from '@common/common-test-ids.const'

import { selectLoaderOverlayState } from '@stores/layout/layout.selector'
import { useLayoutStore } from '@stores/layout/layout.store'

import { shouldHideAppLoader } from '../../utils/shouldHideAppLoader'
import { DEFAULT_LOADER_MESSAGE } from '../Layout/layout.const'

import styles from './Loader.module.scss'

export function Loader() {
  const pathname = usePathname()
  const { isLoading, loaderMessage, showLoaderOnSettings } = useLayoutStore(useShallow(selectLoaderOverlayState))

  if (shouldHideAppLoader({ isLoading, pathname, showOnSettings: showLoaderOnSettings })) {
    return null
  }

  return (
    <div className={styles.overlay} data-testid={LOADER_TEST_IDS.root}>
      <div className={styles.container}>
        <div className={styles.loader}>
          <div className={styles.spinner}></div>
        </div>

        <Paragraph size="sm" className={styles.message}>
          {loaderMessage ?? DEFAULT_LOADER_MESSAGE}
        </Paragraph>
      </div>
    </div>
  )
}
